
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("FbWdM", function(module, exports) {
"use strict";
function $07bd17192a58dfc8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $07bd17192a58dfc8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $07bd17192a58dfc8$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = module.exports.getUcService = module.exports.getUcData = module.exports.checkUcInit = module.exports.acceptUcService = void 0;
function $07bd17192a58dfc8$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $07bd17192a58dfc8$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $07bd17192a58dfc8$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($07bd17192a58dfc8$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $07bd17192a58dfc8$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $07bd17192a58dfc8$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $07bd17192a58dfc8$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $07bd17192a58dfc8$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
// =============================================================================
// usercentrics module
// =============================================================================
var $07bd17192a58dfc8$var$updateEvent = new CustomEvent("asuc-updated");
var $07bd17192a58dfc8$var$data = {
    v: null,
    services: {},
    consent: {}
};
var $07bd17192a58dfc8$var$checkUcVersion = function checkUcVersion() {
    if (typeof usercentrics !== "undefined") $07bd17192a58dfc8$var$data.v = 1;
    else if (typeof __ucCmp !== "undefined") $07bd17192a58dfc8$var$data.v = 3;
    else if (typeof UC_UI !== "undefined") $07bd17192a58dfc8$var$data.v = 2;
};
var $07bd17192a58dfc8$var$getUcData = module.exports.getUcData = /*#__PURE__*/ function() {
    var _ref = $07bd17192a58dfc8$var$_asyncToGenerator(/*#__PURE__*/ $07bd17192a58dfc8$var$_regeneratorRuntime().mark(function _callee() {
        return $07bd17192a58dfc8$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!($07bd17192a58dfc8$var$data.v === 3)) {
                        _context.next = 3;
                        break;
                    }
                    _context.next = 3;
                    return __ucCmp.getConsentDetails().then(function(response) {
                        // console.log(response);
                        $07bd17192a58dfc8$var$data.consent = response.consent;
                        $07bd17192a58dfc8$var$data.services = response.services;
                    });
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getUcData() {
        return _ref.apply(this, arguments);
    };
}();
var $07bd17192a58dfc8$var$getUcService = module.exports.getUcService = function getUcService(id) {
    if ($07bd17192a58dfc8$var$data.v === 1) ;
    else if ($07bd17192a58dfc8$var$data.v === 2) {
        var s = UC_UI.getServicesBaseInfo().find(function(data) {
            return data.id === id;
        });
        return s && s.consent.status ? true : false;
    } else if ($07bd17192a58dfc8$var$data.v === 3) {
        var _data$services$id;
        return (_data$services$id = $07bd17192a58dfc8$var$data.services[id]) === null || _data$services$id === void 0 || (_data$services$id = _data$services$id.consent) === null || _data$services$id === void 0 ? void 0 : _data$services$id.given;
    }
};
var $07bd17192a58dfc8$var$checkUcInit = module.exports.checkUcInit = /*#__PURE__*/ function() {
    var _ref2 = $07bd17192a58dfc8$var$_asyncToGenerator(/*#__PURE__*/ $07bd17192a58dfc8$var$_regeneratorRuntime().mark(function _callee2() {
        var isInitialized;
        return $07bd17192a58dfc8$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    isInitialized = false;
                    if (!($07bd17192a58dfc8$var$data.v === 1)) {
                        _context2.next = 4;
                        break;
                    }
                    _context2.next = 12;
                    break;
                case 4:
                    if (!($07bd17192a58dfc8$var$data.v === 2)) {
                        _context2.next = 8;
                        break;
                    }
                    if (window.UC_UI && window.UC_UI.isInitialized()) isInitialized = true;
                    _context2.next = 12;
                    break;
                case 8:
                    if (!($07bd17192a58dfc8$var$data.v === 3)) {
                        _context2.next = 12;
                        break;
                    }
                    _context2.next = 11;
                    return __ucCmp.isInitialized();
                case 11:
                    isInitialized = _context2.sent;
                case 12:
                    return _context2.abrupt("return", isInitialized);
                case 13:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function checkUcInit() {
        return _ref2.apply(this, arguments);
    };
}();
var $07bd17192a58dfc8$var$acceptUcService = module.exports.acceptUcService = /*#__PURE__*/ function() {
    var _ref3 = $07bd17192a58dfc8$var$_asyncToGenerator(/*#__PURE__*/ $07bd17192a58dfc8$var$_regeneratorRuntime().mark(function _callee3(id) {
        var service, serviceConsents;
        return $07bd17192a58dfc8$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    $07bd17192a58dfc8$var$checkUcVersion();
                    if (!($07bd17192a58dfc8$var$data.v === 1)) {
                        _context3.next = 5;
                        break;
                    }
                    usercentrics.updateConsents([
                        {
                            templateId: id,
                            status: true
                        }
                    ]);
                    _context3.next = 23;
                    break;
                case 5:
                    if (!($07bd17192a58dfc8$var$data.v === 2)) {
                        _context3.next = 10;
                        break;
                    }
                    UC_UI.acceptService(id);
                    document.dispatchEvent($07bd17192a58dfc8$var$updateEvent);
                    _context3.next = 23;
                    break;
                case 10:
                    if (!($07bd17192a58dfc8$var$data.v === 3)) {
                        _context3.next = 23;
                        break;
                    }
                    service = $07bd17192a58dfc8$var$data.services[id];
                    if (!(service !== undefined)) {
                        _context3.next = 23;
                        break;
                    }
                    serviceConsents = [
                        {
                            id: id,
                            consent: true
                        }
                    ];
                    _context3.next = 16;
                    return __ucCmp.updateServicesConsents(serviceConsents);
                case 16:
                    _context3.next = 18;
                    return __ucCmp.saveConsents();
                case 18:
                    _context3.next = 20;
                    return __ucCmp.refreshScripts();
                case 20:
                    _context3.next = 22;
                    return $07bd17192a58dfc8$var$getUcData();
                case 22:
                    document.dispatchEvent($07bd17192a58dfc8$var$updateEvent);
                case 23:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function acceptUcService(_x) {
        return _ref3.apply(this, arguments);
    };
}();
var $07bd17192a58dfc8$var$init = module.exports.init = function init() {
    $07bd17192a58dfc8$var$checkUcVersion();
    $07bd17192a58dfc8$var$getUcData();
    var acceptBtns = document.querySelectorAll(".asuc-accept");
    acceptBtns.forEach(function(btn) {
        btn.addEventListener("click", /*#__PURE__*/ $07bd17192a58dfc8$var$_asyncToGenerator(/*#__PURE__*/ $07bd17192a58dfc8$var$_regeneratorRuntime().mark(function _callee4() {
            return $07bd17192a58dfc8$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return $07bd17192a58dfc8$var$acceptUcService(btn.dataset.id);
                    case 2:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4);
        })));
    });
    var attempts = 0;
    var _whenComplete = /*#__PURE__*/ function() {
        var _ref5 = $07bd17192a58dfc8$var$_asyncToGenerator(/*#__PURE__*/ $07bd17192a58dfc8$var$_regeneratorRuntime().mark(function _callee5() {
            return $07bd17192a58dfc8$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        $07bd17192a58dfc8$var$checkUcVersion();
                        if (!(++attempts > 30)) {
                            _context5.next = 3;
                            break;
                        }
                        return _context5.abrupt("return");
                    case 3:
                        _context5.next = 5;
                        return $07bd17192a58dfc8$var$checkUcInit();
                    case 5:
                        if (!_context5.sent) {
                            _context5.next = 10;
                            break;
                        }
                        document.dispatchEvent($07bd17192a58dfc8$var$updateEvent);
                        if ($07bd17192a58dfc8$var$data.v === 2) {
                            window.addEventListener("ucEvent", function(event) {
                                $07bd17192a58dfc8$var$getUcData();
                                document.dispatchEvent($07bd17192a58dfc8$var$updateEvent);
                            });
                            window.addEventListener("UC_UI_CMP_EVENT", function(event) {
                                $07bd17192a58dfc8$var$getUcData();
                                document.dispatchEvent($07bd17192a58dfc8$var$updateEvent);
                            });
                        } else if ($07bd17192a58dfc8$var$data.v === 3) window.addEventListener("UC_CONSENT", function(event) {
                            $07bd17192a58dfc8$var$getUcData();
                            document.dispatchEvent($07bd17192a58dfc8$var$updateEvent);
                        });
                        _context5.next = 11;
                        break;
                    case 10:
                        setTimeout(function() {
                            return _whenComplete();
                        }, 500);
                    case 11:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5);
        }));
        return function whenComplete() {
            return _ref5.apply(this, arguments);
        };
    }();
    _whenComplete();
};

});


//# sourceMappingURL=usercentrics.module.c0b0bb9f.js.map
